import React, { useCallback, useEffect, useMemo, useState } from "react";

import { BsArrowLeft, BsQrCodeScan } from "react-icons/bs";
import { coins, getNetworkLabel } from "../../../constants/constants";
import { useUser } from "../../../context/user-context";
import useAuthAxios from "../../../utils/baseAxios";
import PortionAmount from "../../../components/PortionAmount";
import { formatAmount } from "../../../utils/formatTime";
import { validateWalletAddress } from "../../../utils/validateWallet";
import toast from "react-hot-toast";
import { useDebounce } from "use-debounce";

import { API } from "../../../constants/api";
import { useQuery } from "@tanstack/react-query";

import { Scanner } from "@yudiel/react-qr-scanner";
import { errorMessage } from "../../../utils/errorMessage";
import usePublicWalletDetails from "../../../hooks/usePublicWalletDetails";
import {
  computeAmountReceived,
  computeWithdrawalFee,
  getEffectiveMinimum,
  getSupportedNetworks,
  getWithdrawalConfig,
  isBelowMinimum,
} from "../../../utils/asset-config";

const WithdrawToExAddy = ({
  setOpenWithdraw,
  setOpenWithdrawExWallet,
  setOpenWithdrawPreviewEx,
  selectedCoinObjj,
  openWithdrawPreviewEx,
  setNetwork,
  setFee,
  setNewAmount,
  network,
  exWalletAddy,
  amount,
  setExWalletAddy,
  setAmount,
  setSelectedCoinObjw,
  selectedCoinObjw,
}: any) => {
  const axiosInstance = useAuthAxios();

  const { userDetails } = useUser();

  const [coinBalancee, setCoinBalancee] = useState<number | null>(null);
  const [disabled, setDisabled] = useState<boolean>(false);
  const [isValidAddress, setIsValidAddress] = useState(false);

  const walletBalances = userDetails?.user.deexWalletBalances;

  const [scan, setScan] = useState(false);
  const [openBeneficiaries, setOpenBeneficiaries] = useState(false);

  const { data: walletDetails, isPending: walletDetailsPending } =
    usePublicWalletDetails();

  const withdrawalConfig = useMemo(
    () => getWithdrawalConfig(walletDetails, selectedCoinObjw?.abbr, network),
    [walletDetails, selectedCoinObjw?.abbr, network],
  );

  const networkOptions = useMemo(
    () => getSupportedNetworks(walletDetails, selectedCoinObjw?.abbr),
    [walletDetails, selectedCoinObjw?.abbr],
  );

  const handleScan = (data: any) => {
    if (data) {
      setExWalletAddy(data[0].rawValue); // Set the scanned data to exWalletAddy
      setScan(false); // Close the scanner after scanning
    }
  };

  const handleError = (err: any) => {
    console.error("QR Scanner Error: ", err);
    toast.error(err.message);
  };
  const handleCoinChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedAbbr = e.target.value;
    const selectedAbbrLC = e.target.value.toLowerCase();
    setAmount("");
    setNetwork("");
    const coin = coins.find((coin: any) => coin.abbr === selectedAbbr);
    setSelectedCoinObjw(coin);
    const coinBalance = walletBalances[selectedAbbrLC];

    if (coinBalance !== undefined) {
      setCoinBalancee(coinBalance);
      // Here, you can display the balance in the UI, like updating state
    } else {
    }
  };
  useEffect(() => {
    if (selectedCoinObjj) {
      setSelectedCoinObjw(selectedCoinObjj); // Set pre-selected coin
      const selectedAbbr = selectedCoinObjj?.abbr;
      const selectedAbbrLC = selectedCoinObjj?.abbr.toLowerCase();
      setNetwork("");
      const coin = coins.find((coin: any) => coin.abbr === selectedAbbr);
      setSelectedCoinObjw(coin);
      const coinBalance = walletBalances[selectedAbbrLC];

      if (coinBalance !== undefined) {
        setCoinBalancee(coinBalance);
        // Here, you can display the balance in the UI, like updating state
      } else {
      }
    }
  }, [selectedCoinObjj, walletBalances]);

  const isNumber = (str: any) => {
    if (str.trim() === "") {
      return false;
    }

    return !isNaN(str);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (isNumber(value)) {
      setAmount(value);
    } else {
      setAmount("");
    }
  };

  const [debouncedExWalletAddy] = useDebounce(exWalletAddy, 800);
  const validateAddress = useCallback(() => {
    // Ensure we wait for debounce and validate correctly
    if (
      debouncedExWalletAddy === undefined ||
      debouncedExWalletAddy.trim() === ""
    ) {
      return false;
    }

    if (network && selectedCoinObjw) {
      const isValid = validateWalletAddress(
        debouncedExWalletAddy,
        selectedCoinObjw.abbr,
        network
      );

      // Show error only if the address is invalid
      if (!isValid) {
        toast.error(
          `Invalid ${selectedCoinObjw.abbr} address for the selected network.`
        );
      }

      return isValid;
    }
    return false;
  }, [debouncedExWalletAddy, selectedCoinObjw, network]);
  useEffect(() => {
    const isValid = validateAddress();
    setIsValidAddress(isValid);
  }, [validateAddress]);

  const fee = useMemo(
    () => computeWithdrawalFee(Number(amount), withdrawalConfig),
    [amount, withdrawalConfig],
  );

  const amountReceived = useMemo(
    () => computeAmountReceived(Number(amount), withdrawalConfig),
    [amount, withdrawalConfig],
  );

  const minimumValue = getEffectiveMinimum(withdrawalConfig);
  const belowMinimum = amount ? isBelowMinimum(amount, withdrawalConfig) : false;
  const isNetworkUnavailable = !!network && !withdrawalConfig;

  const isBalanceSufficient = amount ? Number(amount) <= Number(coinBalancee) : true;

  useEffect(() => {
    if (
      !selectedCoinObjw?.abbr ||
      !amount ||
      !network ||
      !isValidAddress ||
      belowMinimum ||
      !isBalanceSufficient ||
      isNetworkUnavailable
    ) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [
    amount,
    coinBalancee,
    selectedCoinObjw?.abbr,
    network,
    exWalletAddy,
    isValidAddress,
    withdrawalConfig,
    isBalanceSufficient,
    belowMinimum,
    isNetworkUnavailable,
  ]);

  useEffect(() => {
    if (amount && !isBalanceSufficient) {
      toast.error("Insufficient balance");
    }
  }, [amount, isBalanceSufficient]);

  //getbeneficiaries
  const getAllBeneficiaries = async () => {
    const response = await axiosInstance.get(API.getBeneficiaries);
    return response.data;
  };

  const { data: allBeneficiaries, error: error2 } = useQuery({
    queryKey: ["all-beneficiaries"],
    queryFn: getAllBeneficiaries,
    retry: 1,
  });
  useEffect(() => {
    if (error2) {
      const newError = error2 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
  }, [error2]);

  // console.log(allBeneficiaries?.data?.items);

  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenWithdrawExWallet(false);
              setOpenWithdraw(true);
              setNetwork("");
            }}
            className="flex items-center gap-2 "
          >
            <BsArrowLeft className=" text-gray-800 dark:text-gray-200 text-[16px]" />
          </button>
          <h4 className="text-gray-900  dark:text-gray-100 font-sora font-semibold text-[18px]">
            Withdraw to External Wallet
          </h4>
        </div>
        <div className="w-full mt-2">
          <div className="w-full py-6 border-b border-b-gray-200 dark:border-gray-600">
            <div className="flex justify-between gap-4 items-center">
              <div className="w-full m">
                <h4 className="text-[15px] text-gray-800 dark:text-gray-200">
                  Amount
                </h4>
                <div className="h-[48px] mt-2 rounded-xl border border-gray-300 dark:border-gray-600 px-2  flex gap-1 justify-between items-center">
                  <input
                    type="number"
                    placeholder="Amount"
                    value={amount}
                    onChange={handleChange}
                    className="text-gray-600 dark:text-gray-400 bg-transparent w-full spin-button-none  text-[13px] text-left outline-none"
                  />
                  <h4 className="text-[13px] text-secondary_button">
                    {selectedCoinObjw?.abbr}
                  </h4>
                </div>
              </div>
            </div>
            <div className="flex mt-3 justify-between items-center">
              {coinBalancee !== null && coinBalancee !== undefined && (
                <h4 className="text-center  text-[11px] xs:text-[13px] font-medium text-gray-700 dark:text-gray-300">
                  Balance:
                  <span className="text-green-700">
                    {formatAmount(coinBalancee)} {selectedCoinObjw?.abbr || ""}
                  </span>
                </h4>
              )}
              <PortionAmount setAmount={setAmount} coinBalance={coinBalancee} />
            </div>
          </div>
          <div className="mt-6">
            <div className="h-[48px] mt-2 rounded-xl border border-gray-300 dark:border-gray-600 px-2  flex gap-1 justify-start items-center">
              <div className="flex justify-center items-center  w-[20px] h-[20px] rounded-full">
                <img
                  src={selectedCoinObjw?.logo ? selectedCoinObjw?.logo : ""}
                  className="w-full h-full bg-cover"
                  alt=""
                />
              </div>
              <select
                value={selectedCoinObjw?.abbr || ""}
                onChange={handleCoinChange}
                className="outline-none bg-transparent w-full  text-[14px] text-gray-800 dark:text-gray-200"
              >
                <option value="" disabled>
                  Select a coin
                </option>
                {coins.map((coin: any, index: any) => (
                  <option key={index} value={coin.abbr}>
                    {coin.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="mt-6">
            <h4 className="text-[14px] text-gray-800 dark:text-gray-200">
              Select Network
            </h4>
            <div className="h-[48px] mt-2 rounded-xl border border-gray-300 dark:border-gray-600 px-2  flex gap-1 justify-start items-center">
              <select
                value={network}
                onChange={(e) => setNetwork(e.target.value)}
                className="outline-none w-full bg-transparent text-[14px] text-gray-800 dark:text-gray-200"
              >
                <option value="" disabled>
                  Select Network
                </option>
                {networkOptions.map((net, index) => (
                  <option key={index} value={net.abbr}>
                    {net.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="w-full mt-4 ">
            <h4 className="text-[14px] text-gray-800 dark:text-gray-200">
              Select Destination
            </h4>

            <div className="flex justify-between text-[13px] mt-3 text-gray-800 dark:text-gray-200  items-center border bg-transparent border-gray-200 dark:border-gray-600 rounded-xl px-4 h-[52px]">
              <input
                type="text"
                placeholder={`Paste ${selectedCoinObjw?.abbr} address`}
                value={exWalletAddy}
                onChange={(e) => setExWalletAddy(e.target.value)}
                className="text-gray-700 dark:text-gray-300 bg-transparent text-[12px] w-11/12  text-left outline-none"
              />
              <BsQrCodeScan
                className="text-secondary_button text-[20px] cursor-pointer"
                onClick={() => {
                  setScan(true);
                  // console.log("OPEN SCANNER");
                }} // Open scanner on click
              />
              {scan && (
                <div className="fixed inset-0 flex px-4 sm:px-6 md:px-20 lg:px-28 xl:px-40 2xl:px-60 items-start pt-32 sm:pt-40 md:pt-48 justify-center bg-black bg-opacity-70 z-50">
                  <div className="w-full max-w-md">
                    <Scanner
                      scanDelay={300}
                      onError={handleError}
                      onScan={handleScan}
                      styles={{
                        container: {
                          width: "100%",
                          height: "auto",
                          maxHeight: "80vh",
                        },
                      }}
                    />
                  </div>

                  <button
                    onClick={() => setScan(false)}
                    className="absolute top-4 right-4 bg-red-500 text-white px-5 py-3 rounded text-sm sm:text-base"
                    aria-label="Close QR Scanner"
                  >
                    Close
                  </button>
                </div>
              )}
            </div>
            {allBeneficiaries?.data?.items?.length > 0 && (
              <button
                onClick={() => setOpenBeneficiaries(true)}
                className="mt-3 border-secondary_button border flex justify-center items-center text-secondary_button text-[13px] font-medium h-[40px] w-full rounded-xl"
              >
                Choose from beneficiaries
              </button>
            )}
          </div>
          {isNetworkUnavailable && (
            <p className="text-[12px] text-red-500 font-medium mt-3">
              {selectedCoinObjw?.abbr} withdrawal for this network is currently
              not available. Please use another network.
            </p>
          )}
          {withdrawalConfig?.source === "fallback" && !walletDetailsPending && (
            <p className="text-[12px] text-amber-600 dark:text-amber-400 font-medium mt-3">
              Showing our saved fee and minimum for this network. We couldn&apos;t
              reach the live rates, so these may be out of date.
            </p>
          )}
          {minimumValue > 0 && network && !isNetworkUnavailable && (
            <p className="text-[11px] text-gray-700 italic font-bold dark:text-gray-300 mt-1">
              Minimum Withdrawal: {minimumValue} {selectedCoinObjw?.abbr}
            </p>
          )}
          {!!amount && belowMinimum && !isNetworkUnavailable && (
            <p className="text-[12px] text-red-500 font-medium mt-1">
              Minimum amount to withdraw is {minimumValue} {selectedCoinObjw?.abbr}
            </p>
          )}
          {!!amount && !isBalanceSufficient && (
            <p className="text-[12px] text-red-500 font-medium mt-1">
              Insufficient balance
            </p>
          )}
          <div className="mt-10">
            <div className="flex justify-between items-center">
              <h4 className="text-[13px] text-secondary_button">Fee</h4>
              <h4 className="text-[13px] text-gray-900 font-bold dark:text-gray-100">
                -{amount && withdrawalConfig ? formatAmount(fee) : "-----"}{" "}
                {selectedCoinObjw?.abbr}
                {withdrawalConfig?.withdrawalFeeType === "PERCENTAGE" &&
                  withdrawalConfig.withdrawalFee > 0 &&
                  ` (${withdrawalConfig.withdrawalFee}%)`}
              </h4>
            </div>
            <div className="flex justify-between items-center mt-2">
              <h4 className="text-[13px] text-secondary_button">
                Total Received
              </h4>
              <h4 className="text-[13px] text-gray-900 font-bold dark:text-gray-100">
                {amount && withdrawalConfig && isBalanceSufficient
                  ? formatAmount(amountReceived)
                  : "-----"}{" "}
                {selectedCoinObjw?.abbr}
              </h4>
            </div>
            <button
              onClick={() => {
                setOpenWithdrawExWallet(false);
                setFee(fee);
                setOpenWithdrawPreviewEx(true);
              }}
              disabled={disabled}
              className={
                disabled
                  ? "mt-8 bg-gray-400 flex justify-center items-center text-gray-200 text-[15px] font-medium h-[48px] w-full rounded-xl"
                  : "mt-8 bg-secondary_button flex justify-center items-center text-white text-[15px] font-medium h-[48px] w-full rounded-xl"
              }
            >
              Proceed to Withdraw
            </button>
          </div>
        </div>
      </div>
      {openBeneficiaries && (
        <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm z-50">
          <div
            className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
          >
            <div className="w-full flex justify-between items-center">
              <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[18px]">
                Select beneficiary
              </h4>
              <button
                onClick={() => setOpenBeneficiaries(false)}
                className="text-[13px] text-secondary_button"
              >
                Close
              </button>
            </div>
            <div className="w-full mt-4">
              {!allBeneficiaries?.data?.items?.length ? (
                <div className="py-10 text-center text-[13px] text-gray-600 dark:text-gray-300">
                  No beneficiaries saved yet.
                </div>
              ) : (
                <div className="flex flex-col gap-3">
                  {allBeneficiaries?.data?.items?.map((item: any) => (
                    <div
                      key={item._id}
                      className="flex justify-between py-3 border rounded-xl px-3 border-gray-200 dark:border-gray-600 items-start"
                    >
                      <button
                        className="text-left w-full pr-3"
                        onClick={() => {
                          const address = item?.crypto?.address || "";
                          const networkFromItem = item?.crypto?.network || "";
                          const currency = item?.crypto?.currency || ""; // e.g. USDT

                          // Apply address and network from beneficiary
                          setExWalletAddy(address);
                          if (networkFromItem) {
                            setNetwork(networkFromItem);
                          }

                          // If the beneficiary includes currency, switch selected coin accordingly
                          if (currency) {
                            const matched = coins.find(
                              (c: any) =>
                                c.abbr?.toUpperCase() === currency.toUpperCase()
                            );
                            if (matched) {
                              setSelectedCoinObjw(matched);
                              // Reset amount to avoid stale validation against previous coin
                              setAmount("");
                              // Update balance reference for the newly selected coin immediately
                              const abbrLc = matched.abbr?.toLowerCase();
                              const newBalance =
                                userDetails?.user?.deexWalletBalances?.[abbrLc];
                              if (newBalance !== undefined) {
                                setCoinBalancee(newBalance);
                              }
                            }
                          }

                          setOpenBeneficiaries(false);
                        }}
                      >
                        <h4 className="text-[#13181B] dark:text-gray-100 font-semibold font-sora text-[14px]">
                          {item.name}
                        </h4>
                        {item.notes && (
                          <p className="text-gray-500 mt-1 text-[12px] font-medium">
                            {item.notes}
                          </p>
                        )}
                        <div className="flex items-center gap-2 mt-2">
                          <span className="text-[12px] text-gray-700 dark:text-gray-300 font-medium">
                            {item?.crypto?.address?.slice(0, 6)}...
                            {item?.crypto?.address?.slice(-6)}
                          </span>
                          {item?.crypto?.network && (
                            <span className="text-[10px] px-2 py-0.5 rounded-full font-bold bg-[#E8F3FC] text-secondary_button uppercase">
                              {getNetworkLabel(item.crypto.network)}
                            </span>
                          )}
                        </div>
                      </button>
                      {/* <button
                        onClick={() =>
                          completeDeleteBeneficiary.mutate(item._id)
                        }
                        className="text-red-500 ml-2"
                        aria-label="Delete beneficiary"
                      >
                        {completeDeleteBeneficiary.isPending ? (
                          <ClipLoader color="#ef4444" size={18} />
                        ) : (
                          <RiDeleteBin6Line className="text-[18px]" />
                        )}
                      </button> */}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WithdrawToExAddy;
